import { g as getCookieHandler } from "../../../cookieHandler-ac6954c1.js";
import "./adapter.es.js";
import "../../../cookies-04bd2321.js";
import "../../../utils/logger.es.js";
const EH_PREVIOUS_VISIT_ID = "eh_previous_visit_id";
const processReturnVisitId = (adapter) => {
  const cookieHandler = getCookieHandler(adapter);
  const cookies = cookieHandler.parseCookies();
  if (!cookies[EH_PREVIOUS_VISIT_ID]) {
    return void 0;
  }
  return cookies[EH_PREVIOUS_VISIT_ID];
};
const getReturnVisitId = (adapter) => {
  return processReturnVisitId(adapter);
};
const isReturningVisitor = (adapter) => {
  const eh_previous_visit_id = processReturnVisitId(adapter);
  return eh_previous_visit_id ? true : false;
};
export {
  getReturnVisitId,
  isReturningVisitor
};
